module.exports = __webpack_public_path__ + "static/media/solana.1451c141.svg";